import { Routes, RouterModule } from "@angular/router";
import { CatalogsComponent } from "./catalogs.component";

const catalogsRoutes:Routes=[
    {
        path:'',
        component:CatalogsComponent,
        children:[]
    }
];

export const CatalogsRoutes=RouterModule.forChild(catalogsRoutes);